












import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import MelosMultipleToggle from '@/components/MelosMultipleToggle.vue';
import { MelosPlayerStatus } from '@/components/MelosPlayerInterface.vue';

@Component({
  components: {
    MelosMultipleToggle,
  },
})
export default class MelosPlayerController extends Vue {
  @Prop() private playerStatus!: MelosPlayerStatus;
  @Prop() private canGoBackwards!: boolean;
  @Prop() private canGoForward!: boolean;
  @Prop() private canExpand!: boolean;
  @Prop() private link!: string;
  @Prop() private canTransmit!: boolean;
  @Prop() private trackTitle!: string;

  private get options(): any[] {
    const playerOptions = [];

    if (this.canExpand) {
      playerOptions.push({ label: 'e', active: this.$route.name === 'playing', action: 'expand' });
    }
    if (this.link !== undefined) {
      playerOptions.push({ label: 'link', active: false, action: 'link' });
    }
    if (this.canGoBackwards) {
      playerOptions.push({ label: '<<', active: false, action: 'back' });
    }

    playerOptions.push( {
      label: '|>',
      active: this.playerStatus === MelosPlayerStatus.PLAYING,
      action: 'togglePlay',
    });

    if (this.canGoForward) {
      playerOptions.push({ label: '>>', active: false, action: 'forward' });
    }
    if (this.canTransmit) {
      playerOptions.push({
        label: 'transmit',
        active: this.$store.state.player?.loop,
        action: 'transmit',
      });
    }

    return playerOptions;
  }

  private onItemClick(index: number) {
    if (index >= this.options.length) {
      return;
    }

    this.$emit(this.options[index].action);
  }

}

